import { USER_COOKIE } from '../containers/App/constants';
import { cookiesExpiresDate } from './index';
import * as cookies from 'react-cookies';

export const cookieSaveUserCookie = (value) =>
  cookies.save(USER_COOKIE, value, {
    path: '/',
    expires: cookiesExpiresDate(),
  });
